import { render, staticRenderFns } from "./VuesticProgressBar.vue?vue&type=template&id=26f8355a"
import script from "./VuesticProgressBar.vue?vue&type=script&lang=js"
export * from "./VuesticProgressBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26f8355a')) {
      api.createRecord('26f8355a', component.options)
    } else {
      api.reload('26f8355a', component.options)
    }
    module.hot.accept("./VuesticProgressBar.vue?vue&type=template&id=26f8355a", function () {
      api.rerender('26f8355a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-progress-bar/VuesticProgressBar.vue"
export default component.exports